<script lang="ts" setup>
import { useRouter } from 'vue-router'

interface Props {
  yonergeOnaylandiMi: boolean
}

defineProps<Props>()
const router = useRouter()
</script>

<template>
  <div
    class="w-full p-3 space-y-2 flex flex-col items-center justify-center px-4 md:px-6"
    v-if="yonergeOnaylandiMi"
  >
    <MIcon name="check_circle" size="20px" class="text-gray-400" filled />
    <span class="text-body-md text-gray-400">
      {{ $t('terms_status.approved_message') }}
    </span>
  </div>

  <div v-else>
    <div class="w-full p-3 space-y-2 flex flex-col items-center justify-center px-4 md:px-6">
      <span class="text-body-md text-gray-400">
        {{ $t('terms_status.approval_required_message') }}
      </span>
      <MIcon name="keyboard_arrow_down" class="text-gray-400" />
    </div>

    <div
      class="card w-full p-3 space-y-2 flex md:flex-row flex-col md:items-center items-start md:justify-between justify-start px-4 md:px-6 bg-orange-600 gap-4"
    >
      <MIcon name="brightness_alert" size="20px" class="text-white" filled />
      <div>
        <h3 class="text-title-md text-white">{{ $t('terms_status.approve_title') }}</h3>
        <p class="text-body-md text-orange-200">
          {{ $t('terms_status.approve_description') }}
        </p>
      </div>
      <button
        type="button"
        class="btn btn-white bg-white text-orange-600 w-auto"
        @click="router.push('/yonerge')"
      >
        <span>{{ $t('terms_status.go_to_sartname_button') }}</span>
        <MIcon name="arrow_forward" size="20px" class="text-orange-600" />
      </button>
    </div>
  </div>
</template>
